import { memo } from "react";
import classNames from "classnames";
import Moment from "react-moment";
import { ListGroupItem, ListGroup, Badge } from "shards-react";
import "moment-timezone";

import ToolTipContent from "./ToolTipContent";
import ToolTipIcon from "./ToolTipIcon";

const DocumentInfo = ({
  documentId,
  thumbnailUrl,
  infoBox,
  failed,
  downloadConfirmations,
}) => {
  const handleStatus = (value) => {
    const statusStyle = {
      theme: "danger",
      icon: "exclamation",
      title: "Keine Seiten wurden erkannt",
    };

    if (value === 1) {
      statusStyle.theme = "success";
      statusStyle.icon = "check";
      statusStyle.title = "Alle Seiten wurden erkannt";
    }

    if (value === 2) {
      statusStyle.theme = "warning";
      statusStyle.icon = "question";
      statusStyle.title = "Mindestens eine Seite wurde nicht erkannt";
    }

    return (
      <Badge pill outline theme={statusStyle.theme}>
        <i className={`fas fa-${statusStyle.icon}-circle mr-1`} />
        {statusStyle.title}
      </Badge>
    );
  };

  const handleDateFormat = (date) => {
    return (
      <Moment format="HH:mm:ss, DD.MM.YYYY" interval={0} tz="Europe/Berlin">
        {date}
      </Moment>
    );
  };

  const handleSignStatus = (name, value, workstepInfo) => {
    const { numWorksteps, currentWorkstep } = workstepInfo;

    const stepString = currentWorkstep
      ? `(Schritt ${currentWorkstep} von ${numWorksteps})`
      : "";

    const newValue = value === "Entwurf" ? value : `${value} ${stepString}`;

    const showTooltip = value === "Entwurf" || currentWorkstep;

    const toolTipData = {
      name,
      value,
      workstepInfo,
    };

    return (
      <div>
        {newValue}
        {showTooltip && (
          <ToolTipIcon tipContent={<ToolTipContent data={toolTipData} />} />
        )}
      </div>
    );
  };

  const handleValueToDisplay = (info, isSignStatusInfo = false) => {
    const { name, value, workstepInfo } = info;

    if (!value)
      return <i className="fas fa-minus-circle complement-color ml-2" />;

    if (isSignStatusInfo) return handleSignStatus(name, value, workstepInfo);

    if (name === "Status: ") return handleStatus(value);
    if (
      name === "Eingangsdatum: " ||
      name === "Zuletzt geändert: " ||
      name === "Ablaufsdatum: " ||
      name === "abgebrochen: " ||
      name === "Abgeholt: "
    )
      return handleDateFormat(value);

    return value;
  };

  return (
    <ListGroup className="ml-3 info-box h-100 justify-content-center flex-grow-1">
      <ListGroupItem className="p-2">
        <strong>ID: </strong>
        {documentId}
      </ListGroupItem>
      {infoBox?.map((info) => {
        const isDownloadedInfo = info?.name?.trim() === "Abgeholt:";

        if (
          isDownloadedInfo &&
          (!Array.isArray(downloadConfirmations) ||
            downloadConfirmations.length === 0)
        )
          return null;

        const classes = classNames(
          "p-2",
          "custom-list-group-item",
          thumbnailUrl
            ? failed
              ? "text-warning"
              : info.textWrap
                ? ""
                : "text-nowrap"
            : "text-warning",
        );

        const isSignStatusInfo =
          info?.name?.includes("Status der Unterschriftenmappe") &&
          !infoBox.some(
            (info) =>
              info.value ===
              "Das Dokument wird verarbeitet. Bitte haben Sie etwas Geduld!",
          );

        const showDownloadTooltip =
          isDownloadedInfo &&
          Array.isArray(downloadConfirmations) &&
          downloadConfirmations.length > 0;

        let valueToDisplay = handleValueToDisplay(info, isSignStatusInfo);

        return (
          <ListGroupItem
            key={`${info.name}${documentId}`}
            className={`${classes}`}
          >
            {info.name && (
              <strong>{isSignStatusInfo ? "Status:" : info.name}</strong>
            )}
            <span
              className={
                info?.name?.toLowerCase().includes("referenz")
                  ? "truncate-text"
                  : ""
              }
            >
              {valueToDisplay}
              {showDownloadTooltip && (
                <ToolTipIcon
                  tipContent={
                    <ToolTipContent data={{ downloadConfirmations }} />
                  }
                />
              )}
            </span>
          </ListGroupItem>
        );
      })}
    </ListGroup>
  );
};

export default memo(DocumentInfo);
